import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLink } from '@fortawesome/pro-light-svg-icons'

import classnames from 'classnames'

import { useSetState } from '@domain-group/react-hooks'

import { Box, LoadingBubbles, Text } from '@domain-group/suit-theme'

import type { HandleCallbackActionParams } from '@functions/handleCallbackAction'

import { PropertySuggestionModel } from '@models/types'

import type { ModalCallbacks } from '@modals/BrowseCampaignComparablesModal'

import type { UseBrowseCampaignComparablesModalPayload } from '../../hooks/useBrowseCampaignComparablesModal'

import styles from './styles.module.scss'

interface ProperyMatchSuggestion extends PropertySuggestionModel {
  full_address?: string,
}

const defaultState = {
  loading: false,
}

type SetState = (state: Partial<typeof defaultState>) => void

type PropertySuggestionProps = {
  callbacks: ModalCallbacks,
  hookPayload: UseBrowseCampaignComparablesModalPayload,
  suggestion: ProperyMatchSuggestion,
}

type SelectPropertyParams = {
  callbacks: PropertySuggestionProps['callbacks'],
  updateCampaignDataProviderPayload: HandleCallbackActionParams,
  setState: SetState,
}

const selectProperty = async (params: SelectPropertyParams) => {
  const { callbacks, updateCampaignDataProviderPayload, setState } = params
  const { updateCampaignDataProvider } = callbacks

  setState({ loading: true })
  await updateCampaignDataProvider(updateCampaignDataProviderPayload)
  setState({ loading: false })
}

const PropertySuggestion = (props: PropertySuggestionProps) => {
  const {
    callbacks,
    hookPayload,
    suggestion,
  } = props

  const [state, setState] = useSetState(defaultState)
  const { loading } = state

  const {
    address,
    data_provider,
    full_address,
    legal_description,
    post_code,
    state_name,
    suburb_name,
  } = suggestion

  const {
    callbacks: {
      updateCampaignDataProvider: createFn,
    },
  } = hookPayload

  const updateCampaignDataProviderPayload = {
    callbacks: {
      action: createFn,
    },
    entityParams: suggestion,
    toastText: 'Property Matched',
  }

  return (
    <Box
      className={classnames(styles.root, styles.hoverStyle)}
      // @ts-expect-error TS2322
      onClick={() => selectProperty({ callbacks, updateCampaignDataProviderPayload, setState })}
      marginBottom="large"
      padding="large"
      variant="white"
    >
      {data_provider === 'core_logic' && (
        // @ts-expect-error TS2820
        <Box flexDirection="Column" minWidth="80%">
          <Text fontSize="xsmall" color="bodyFontLightColor" variant="twoLineEllipsis">
            {full_address}
          </Text>
        </Box>
      )}

      {data_provider !== 'core_logic' && (
        // @ts-expect-error TS2820
        <Box flexDirection="Column" minWidth="80%">
          <Text fontSize="small" marginBottom="small">{address}</Text>

          <Text
            color="bodyFontLightColor"
            fontSize="xsmall"
          >
            {suburb_name} {state_name} {post_code} {legal_description && `(${legal_description})`}
          </Text>
        </Box>
      )}

      <Box color="bodyFontLightColor" minWidth="20%" justifyContent="flex-end" overflow="hidden" margin="auto">
        {loading && <LoadingBubbles />}

        {!loading && (
          <FontAwesomeIcon
            className={styles.linkIcon}
            icon={faLink}
          />
        )}
      </Box>
    </Box>
  )
}

export default PropertySuggestion
